import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type SubjectMembersFetchFailedAction = {
	type: 'SUBJECT_MEMBERS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): SubjectMembersFetchFailedAction => ({
	type: 'SUBJECT_MEMBERS_FETCH_FAILED',
	payload,
});
